import { useRouteMatch, useLocation } from 'react-router-dom';
import { EXISTING_PRODUCTS, SUPERADMIN_PRODUCT, CLIENT_PRODUCT } from 'constants/products.js';
import { isOrgId } from 'hooks/useOrgId.js';
import { CLIENT_BASE, SUPERADMIN_ROUTES } from 'constants/routes.js';

const useProductDataOutsideRoutes = () => {
  const location = useLocation();
  const match = useRouteMatch('/:orgId/:selectedProduct/:page?/:pageId?');
  const clientRouteMatch = useRouteMatch(CLIENT_BASE);

  const { params: matchParams = {} } = match || {};
  const { params: clientRouteMatchParams = {} } = clientRouteMatch || {};

  const isSuperAdminRoute = SUPERADMIN_ROUTES.some((route) => route === location.pathname);

  const selectedProduct = (() => {
    if (EXISTING_PRODUCTS.includes(matchParams.selectedProduct)) {
      return matchParams.selectedProduct;
    } else if (isSuperAdminRoute) {
      return SUPERADMIN_PRODUCT;
    } else if (clientRouteMatchParams.clientId) {
      return CLIENT_PRODUCT;
    }
  })();


  const orgId = isOrgId(matchParams.orgId) ? matchParams.orgId : null;
  const page = matchParams.page;
  const pageId = matchParams.pageId;
  const clientId = clientRouteMatchParams.clientId || null;

  return { orgId, selectedProduct, page, pageId, clientId };
};

export default useProductDataOutsideRoutes;
